// Generado por la división del monolito. Importa helpers de ./common.jsx.
import { useState, useEffect, useCallback, Toast, SUGGESTION_STATUS_META } from './common.jsx';

export function SuggestionsPage({activeUser, isManager=false, allUsers=[], isReadOnly=false}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({title: '', body: ''});
  const [submitting, setSubmitting] = useState(false);
  const [filter, setFilter] = useState('all'); // all | pending | planned | inProgress | discarded | completed
  const [toast, setToast] = useState(null);
  const [editing, setEditing] = useState(null); // id del item editando estado

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch('/api/suggestions');
      setItems(await r.json());
    } catch(e) { setItems([]); }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async () => {
    if (!form.title.trim()) return;
    setSubmitting(true);
    try {
      await fetch('/api/suggestions', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          title: form.title, body: form.body,
          userId: activeUser?.id, userName: activeUser?.name, userRole: activeUser?.role
        })
      });
      setForm({title:'', body:''});
      setToast({message:'Sugerencia enviada · gracias!', type:'ok'});
      load();
    } catch { setToast({message:'Error al enviar', type:'err'}); }
    setSubmitting(false);
  };
  const setStatus = async (id, status) => {
    await fetch(`/api/suggestions/${id}`, {
      method: 'PATCH', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ status, actorName: activeUser?.name })
    });
    setEditing(null);
    load();
  };
  const remove = async (id, title) => {
    if (!confirm(`¿Borrar sugerencia "${title.slice(0,60)}"?`)) return;
    await fetch(`/api/suggestions/${id}`, { method: 'DELETE' });
    load();
  };

  // Lista visible:
  //  - Manager: todas las sugerencias del equipo (con filtro de estado)
  //  - Resto: solo las del propio user (las que él envió)
  const visibleItems = isManager
    ? items.filter(i => filter==='all' || i.status===filter)
    : items.filter(i => i.createdBy?.userId === activeUser?.id);
  // Conteo por estado para los pills (solo en manager)
  const counts = items.reduce((acc, i) => { acc[i.status] = (acc[i.status]||0)+1; return acc; }, {});

  return (
    <>
      <div className="topbar">
        <div>
          <h2>{isManager ? 'Sugerencias del equipo' : 'Enviar sugerencia'}</h2>
          <p>{isManager
            ? 'Tickets enviados por el equipo · gestiona estados de cada uno'
            : 'Reporta bugs o ideas de mejora · el manager los revisa'}</p>
        </div>
      </div>
      <div className="page">
        {/* Form de nueva sugerencia — disponible para todos */}
        {!isReadOnly && (
          <div className="card" style={{padding:'16px 18px',marginBottom:18}}>
            <div style={{fontSize:13,fontWeight:700,color:'var(--tx)',marginBottom:10}}>Nueva sugerencia</div>
            <div style={{display:'flex',flexDirection:'column',gap:10}}>
              <input className="fi" placeholder="Título corto y descriptivo (obligatorio)" value={form.title}
                onChange={e=>setForm(f=>({...f, title:e.target.value}))} style={{width:'100%'}}/>
              <textarea className="fi" rows={4} placeholder="Cuenta el detalle: contexto, qué esperas que pase, capturas o pasos para reproducir si es un bug…" value={form.body}
                onChange={e=>setForm(f=>({...f, body:e.target.value}))} style={{width:'100%',resize:'vertical'}}/>
              <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
                <button className="btn btn-pu" onClick={submit} disabled={submitting || !form.title.trim()}>
                  {submitting ? 'Enviando…' : 'Enviar sugerencia'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Filtros por estado (solo manager) */}
        {isManager && items.length > 0 && (
          <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:14}}>
            <button onClick={()=>setFilter('all')} style={{
              background: filter==='all' ? 'var(--pu)' : 'var(--bg)',
              color: filter==='all' ? '#fff' : 'var(--tx-mu)',
              border: 'none', padding: '6px 12px', borderRadius: 999,
              fontSize: 12, fontWeight: 600, cursor: 'pointer'
            }}>Todas <span style={{opacity:.7,marginLeft:4}}>{items.length}</span></button>
            {Object.entries(SUGGESTION_STATUS_META).map(([k, meta]) => (
              <button key={k} onClick={()=>setFilter(k)} style={{
                background: filter===k ? meta.color : meta.bg,
                color: filter===k ? '#fff' : meta.color,
                border: 'none', padding: '6px 12px', borderRadius: 999,
                fontSize: 12, fontWeight: 600, cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', gap: 6
              }}>
                <span>{meta.icon}</span>
                <span>{meta.label}</span>
                <span style={{opacity:.7,marginLeft:2}}>{counts[k]||0}</span>
              </button>
            ))}
          </div>
        )}

        {/* Lista de tickets */}
        {loading ? (
          <div className="card" style={{padding:20,textAlign:'center',color:'var(--tx-mu)',fontSize:13}}>Cargando…</div>
        ) : visibleItems.length === 0 ? (
          <div className="card" style={{padding:'24px 20px'}}>
            <div className="em">
              <h3>{isManager ? 'Sin sugerencias en este estado' : 'Aún no has enviado ninguna sugerencia'}</h3>
              <p>{isManager ? 'Cambia el filtro o espera a que el equipo te envíe ideas.' : 'Cuéntanos un bug o una idea de mejora arriba.'}</p>
            </div>
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:10}}>
            {visibleItems.map(s => {
              const meta = SUGGESTION_STATUS_META[s.status] || SUGGESTION_STATUS_META.pending;
              return (
                <div key={s.id} className="card" style={{padding:'14px 18px'}}>
                  <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12,flexWrap:'wrap',marginBottom:6}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:700,color:'var(--tx)',wordBreak:'break-word'}}>{s.title}</div>
                      <div style={{fontSize:11,color:'var(--tx-mu)',marginTop:3}}>
                        {s.createdBy?.userName || '?'} · {s.createdBy?.userRole || '—'} · {s.createdAt ? new Date(s.createdAt).toLocaleDateString('es-ES',{day:'2-digit',month:'short',year:'numeric'}) : '—'}
                      </div>
                    </div>
                    {/* Chip de estado: clickable si manager */}
                    {isManager && !isReadOnly ? (
                      <span onClick={()=>setEditing(editing===s.id?null:s.id)} style={{
                        fontSize:11,fontWeight:600,
                        background:meta.bg,color:meta.color,
                        borderRadius:999,padding:'4px 12px',display:'inline-flex',alignItems:'center',gap:6,
                        cursor:'pointer'
                      }}>
                        <span>{meta.icon}</span>
                        <span>{meta.label}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width:11,height:11,opacity:.7}}><polyline points="6 9 12 15 18 9"/></svg>
                      </span>
                    ) : (
                      <span style={{
                        fontSize:11,fontWeight:600,
                        background:meta.bg,color:meta.color,
                        borderRadius:999,padding:'4px 12px',display:'inline-flex',alignItems:'center',gap:6
                      }}>
                        <span>{meta.icon}</span><span>{meta.label}</span>
                      </span>
                    )}
                  </div>
                  {s.body && (
                    <div style={{fontSize:13,color:'var(--tx2)',whiteSpace:'pre-wrap',marginTop:6,padding:'8px 10px',background:'var(--bg)',borderRadius:6}}>{s.body}</div>
                  )}
                  {/* Editor de estado expandido (solo manager) */}
                  {isManager && editing===s.id && (
                    <div style={{marginTop:10,paddingTop:10,borderTop:'1px solid var(--bds)'}}>
                      <div style={{fontSize:11,fontWeight:600,color:'var(--tx-mu)',textTransform:'uppercase',letterSpacing:'.5px',marginBottom:6}}>Cambiar estado a</div>
                      <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                        {Object.entries(SUGGESTION_STATUS_META).map(([k, m]) => (
                          <button key={k} onClick={()=>setStatus(s.id, k)} style={{
                            background: s.status===k ? m.color : m.bg,
                            color: s.status===k ? '#fff' : m.color,
                            border: 'none', padding: '6px 12px', borderRadius: 999,
                            fontSize: 12, fontWeight: 600, cursor: s.status===k ? 'default' : 'pointer',
                            display: 'inline-flex', alignItems: 'center', gap: 6
                          }} disabled={s.status===k}>
                            <span>{m.icon}</span><span>{m.label}</span>
                          </button>
                        ))}
                        <button className="btn btn-ic btn-rd btn-sm" onClick={()=>remove(s.id, s.title)} style={{marginLeft:'auto'}} title="Borrar sugerencia">🗑️</button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
      {toast && <Toast {...toast} onClose={()=>setToast(null)}/>}
    </>
  );
}
